<template>
  <div class = "upper_bar">
    <div class = "users">
      <a
        ref="user"
        @mouseover="mouseOverUser"
        @mouseleave="mouseLeaveUser"
        @click="userFeed" class = "ss-users">
      </a>
      <!-- <div ref="tool" class="tooltip">User Activity</div> -->
    </div>
    <div class = "heart">
      <a
        ref="heart"
        @mouseover="mouseOverHeart"
        @mouseleave="mouseLeaveHeart"
        @click="charityFeed"
       class = "ss-heart"></a>
      <!-- <div class="tooltiptext">Charity Activity</div> -->
    </div>
    <div @click="closeFeed" class = "delete">
      <a class = "ss-delete"></a>
    </div>
  </div>
</template>

<script>
import {start, current, api_response} from "./entrypoints/sidebar.js"

export default {
    data() {
        return {
          user: false,
          heart: false
        }
    },
    methods: {
      mouseOverUser() {
        if (this.user === false) {
          event.target.style.color="#5A7877";
        }
        const ttBox = document.createElement("div");
        ttBox.id = "f_tooltip";
        ttBox.style.position = "absolute";
        ttBox.style.zIndex = "2000";
        ttBox.style.top = "60px";
        ttBox.style.left = (window.innerWidth - 339).toString() + "px";
        ttBox.style.opacity = "75%";
        document.body.appendChild(ttBox);
        document.getElementById("f_tooltip").innerHTML = "User Activity";
      },
      mouseLeaveUser(){
        if (this.user === false) {
          event.target.style.color="#afc6c0";
        }
        const ttBox = document.getElementById("f_tooltip");
        ttBox.animate({opacity: 0}, 50);
        ttBox.parentNode.removeChild(ttBox);
      },
      mouseOverHeart() {
        if (this.heart === false) {
          event.target.style.color="#5A7877";
        }
        const ttBox = document.createElement("div");
        ttBox.id = "f_tooltip";
        ttBox.style.position = "absolute";
        ttBox.style.zIndex = "2000";
        ttBox.style.top = "60px";
        ttBox.style.left = (window.innerWidth - 301).toString() + "px";
        ttBox.style.width = "97px";
        ttBox.style.opacity = "75%";
        document.body.appendChild(ttBox);
        document.getElementById("f_tooltip").innerHTML = "Charity Activity";
      },
      mouseLeaveHeart(){
        if (this.heart === false) {
          event.target.style.color="#afc6c0";
        }
        const ttBox = document.getElementById("f_tooltip")
        ttBox.animate({opacity: 0}, 50);
        ttBox.parentNode.removeChild(ttBox)
      },
      userFeed() {
        this.user = !this.user;
        // console.log(this.user);
        if(this.heart === true) {
          this.heart = false;
          this.$refs.heart.style="#afc6c0";
        }
        if (this.user === true) {
          event.target.style.color="#ee6840";
          start.user = true;
          start.charity = false;
        }
        else {
          event.target.style.color="#afc6c0";
          start.user = false;
        }
        // console.log("user: " + start.user)
      },
      charityFeed() {
        this.heart = !this.heart;
        // console.log(this.heart);
        if(this.user === true) {
          this.user = false;
          this.$refs.user.style="#afc6c0";
        }
        if (this.heart === true) {
          event.target.style.color="#ee6840";
          start.charity = true;
          start.user = false;
        }
        else {
          event.target.style.color="#afc6c0";
          start.charity = false;
        }
        // console.log("charity: " + start.charity)
      },
      closeFeed() {
          current.toggle()
      }
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    },
}

</script>

<style lang="scss">
@import "./stylesheets/_sidebar.scss";

</style>
